"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const defaultProps = {
  variantMapping: {
    banner: 'div',
    hero: 'div',
    subtitle1: 'div',
    subtitle2: 'div'
  }
};
var _default = exports.default = {
  defaultProps
};
